module.exports = "<div class=\"centerwrap clear\">\n  <br>\n  <p>\n    <h2 class=\"title\"><span>Declined:</span></h2>\n    Your transaction to sign up for AssumeThePositionStudios.com has been Declined. Please try again by clicking the <em>JOIN</em> and choosing either our primary or secondary processor.\n    <br>\n    <br>\n    Thank you,\n    <br>\n    <br>\n    The ATP Team\n    <br>\n    <br>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/ccoDec.html
// module id = 183
// module chunks = 0